/**
 * Address Selection Utilities
 * Helper functions for selecting addresses
 * @see mobile: module-customer/src/modules/addresses/utils/address-selection.utils.ts
 */

import type { CustomerAddress } from '../../../types/front.graphql';

/**
 * Get the default shipping address or the first address in the list
 * @param addresses List of customer addresses
 * @returns Default shipping address or first address
 */
export const getDefaultOrFirstAddress = (addresses: readonly CustomerAddress[]): CustomerAddress | undefined => {
    if (!addresses || addresses.length === 0) return undefined;
    return addresses.find(address => address.default_shipping) ?? addresses[0];
};

/**
 * Check if the selected address is present in the addresses list
 * @param selectedShippingAddress Currently selected address
 * @param addresses List of customer addresses
 * @returns True if selected address is in the list
 */
export const checkSelectedAddressPresent = (
    selectedShippingAddress: CustomerAddress | undefined,
    addresses: readonly CustomerAddress[]
): boolean => {
    const selectedAddressId = selectedShippingAddress?.id;
    return selectedAddressId ? addresses.some(address => address.id === selectedAddressId) : false;
};
